export const BREAKPOINT_NUMBERS = {
  // Taken from antd https://ant.design/components/layout/#breakpoint-width
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600
};

export const BREAKPOINTS = {
  // Taken from antd https://ant.design/components/layout/#breakpoint-width
  xs: `${BREAKPOINT_NUMBERS.xs}px`,
  sm: `${BREAKPOINT_NUMBERS.sm}px`,
  md: `${BREAKPOINT_NUMBERS.md}px`,
  lg: `${BREAKPOINT_NUMBERS.lg}px`,
  xl: `${BREAKPOINT_NUMBERS.xl}px`,
  xxl: `${BREAKPOINT_NUMBERS.xxl}px`
};
